import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";
import ErrorPage from "./ErrorPage";
import { errorTypes } from "./ErrorTypes";

type Props = {
  intl: intlShape;
};

export function Forbidden({ intl }: Props) {
  return (
    <ErrorPage
      header={intl.formatMessage({ id: "forbidden.header" })}
      details={intl.formatMessage({ id: "forbidden.details" })}
      errorType={errorTypes.forbidden}
    />
  );
}

export default injectIntl(Forbidden);
